module.exports = __webpack_public_path__ + "static/media/S3N3.c843b395.svg";